import {
	containerButtonsCarouselContenSecondarytSX,
	containerDpBannerAdsContenMainSX,
	containerInfoDpBannerAdsContentMainSX,
	subtitleDpBannerAdsContentMainSX,
	titleDpBannerAdsContentMainSX,
} from '@/components/blocks/DpLibrary/DpBannerAds/styles/container';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { Img } from '@/components/blocks/MaterialImage';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { combineSX } from '@/utils/combineSX';
import { Grid, Typography, SxProps } from '@mui/material';

type DpAlignVerticalType = 'flex-start' | 'center' | 'flex-end';
type DpAlignHorizontalType = 'flex-start' | 'center' | 'flex-end';
type DpAlignTextTitleType = 'start' | 'center' | 'end';

interface Props {
	image:
		| {
				mobile: string;
				desktop: string;
		  }
		| string;

	propstitle?:
		| {
				mobile: {
					title?: string;
					description?: string;
					buttons?: { name: string; href: string }[];
					backgroundtext?: boolean;
					widthtext?: string;
					heighttext?: string;
					alignverticaltitle?: DpAlignVerticalType;
					alignhorizontaltitle?: DpAlignHorizontalType;
					aligntexttitle?: DpAlignTextTitleType;
					colortext?: string;
				};
				desktop: {
					title?: string;
					description?: string;
					buttons?: { name: string; href: string }[];
					backgroundtext?: boolean;
					widthtext?: string;
					heighttext?: string;
					alignverticaltitle?: DpAlignVerticalType;
					alignhorizontaltitle?: DpAlignHorizontalType;
					aligntexttitle?: DpAlignTextTitleType;
					colortext?: string;
				};
		  }
		| any;
	sxcustom?: SxProps;
	skipmargin?: boolean;
	loading?: 'lazy' | 'eager';
	priority?: boolean;
}

// eslint-disable-next-line complexity
export const DpBannerAds: React.FC<Props> = ({
	image,
	propstitle = {
		mobile: {
			title: '',
			description: '',
			buttons: [],
			backgroundtext: false,
			widthtext: '100%',
			heighttext: '100%',
			alignverticaltitle: 'center' as DpAlignVerticalType,
			alignhorizontaltitle: 'flex-start' as DpAlignHorizontalType,
			aligntexttitle: 'start' as DpAlignTextTitleType,
			colortext: 'red',
		},
		desktop: {
			title: '',
			description: '',
			buttons: [],
			backgroundtext: false,
			widthtext: '100%',
			heighttext: '100%',
			alignverticaltitle: 'center' as DpAlignVerticalType,
			alignhorizontaltitle: 'flex-start' as DpAlignHorizontalType,
			aligntexttitle: 'start' as DpAlignTextTitleType,
			colortext: 'blue',
		},
	},
	sxcustom,
	skipmargin = false,
	priority,
	loading,
}) => {
	const isMobile = useIsMobile();
	const getImage = typeof image === 'string' ? image : isMobile ? image?.mobile : image?.desktop;
	const getTitle =
		typeof propstitle === 'string'
			? propstitle
			: isMobile
			? propstitle?.mobile?.title
			: propstitle?.desktop?.title;
	const getDescription =
		typeof propstitle === 'string'
			? propstitle
			: isMobile
			? propstitle?.mobile?.description
			: propstitle?.desktop?.description;
	const getAlignVerticalTitle =
		typeof propstitle === 'string'
			? propstitle
			: isMobile
			? propstitle?.mobile?.alignverticaltitle
			: propstitle?.desktop?.alignverticaltitle;
	const getAlignHorizontalTitle =
		typeof propstitle === 'string'
			? propstitle
			: isMobile
			? propstitle?.mobile?.alignhorizontaltitle
			: propstitle?.desktop?.alignhorizontaltitle;
	const getHeightText =
		typeof propstitle === 'string'
			? propstitle
			: isMobile
			? propstitle?.mobile?.heighttext
			: propstitle?.desktop?.heighttext;
	const getBackgroundtext =
		typeof propstitle === 'string'
			? propstitle
			: isMobile
			? propstitle?.mobile?.backgroundtext
			: propstitle?.desktop?.backgroundtext;

	const getWidthText =
		typeof propstitle === 'string'
			? propstitle
			: isMobile
			? propstitle?.mobile?.widthtext
			: propstitle?.desktop?.widthtext;
	const getAlignTextTitle =
		typeof propstitle === 'string'
			? propstitle
			: isMobile
			? propstitle?.mobile?.aligntexttitle
			: propstitle?.desktop?.aligntexttitle;
	const getColorText =
		typeof propstitle === 'string'
			? propstitle
			: isMobile
			? propstitle?.mobile?.colortext
			: propstitle?.desktop?.colortext;

	const getButtons = (isMobile ? propstitle?.mobile?.buttons : propstitle?.desktop?.buttons) ?? [];

	return (
		<Grid container sx={containerDpBannerAdsContenMainSX(skipmargin)}>
			<Grid item xs>
				<Img
					src={getImage}
					sx={combineSX([
						{ objectFit: 'cover', width: '100%' },
						...(Array.isArray(sxcustom) ? sxcustom : [sxcustom]),
					])}
					loading={loading}
					priority={priority}
				/>
			</Grid>
			<Grid
				item
				sx={containerInfoDpBannerAdsContentMainSX({
					isMobile,
					justifyContent: getAlignVerticalTitle as DpAlignVerticalType,
					alignItems: getAlignHorizontalTitle as DpAlignHorizontalType,
					heightContainer: getHeightText,
					backgroundTitle: getBackgroundtext as boolean,
				})}
			>
				<Typography
					component="h2"
					sx={titleDpBannerAdsContentMainSX({
						isMobile,
						widthTextTitle: getWidthText,
						alignText: getAlignTextTitle as DpAlignTextTitleType,
						colorText: getColorText,
					})}
				>
					{getTitle}
				</Typography>
				<Typography
					sx={subtitleDpBannerAdsContentMainSX({
						isMobile,
						widthTextTitle: getWidthText,
						alignText: getAlignTextTitle as DpAlignTextTitleType,
						colorText: getColorText,
					})}
				>
					{getDescription}
				</Typography>
				<Grid
					container
					columnSpacing={'18.5px'}
					sx={containerButtonsCarouselContenSecondarytSX({
						alignText: getAlignTextTitle as DpAlignTextTitleType,
					})}
				>
					{getButtons?.map((item: { name: any; href: any }, index: number) => (
						<Grid item key={`id_button_${index}`}>
							<DpButton text={item.name} href={item.href} />
						</Grid>
					))}
				</Grid>
			</Grid>
		</Grid>
	);
};

export const DpPlpBannerAds: React.FC<Props> = (props) => <DpBannerAds skipmargin {...props} />;
